export const enSetPassword = {
	resendInvitation: "Resend invitation",
	invitationResent: "We've sent you a new invitation. Please check your inbox.",
	resendResetLink: "Send new reset link",
	resetLinkResent: "We've sent you a new reset link. Please check your inbox.",
	resetTitle: "Reset your password.",
	resetSubtitle: "Please set a new secure password for your account",
	// The invite screen (PREC-3896). Its placeholder read "Enter your current password", which the
	// invited user does not have — they are creating their first one.
	inviteTitle: "Email confirmed.",
	inviteSubtitle: "Please set a secure password for your account",
	passwordRule: "Please enter a password that contains at least 8 characters",
	setPlaceholder: "Set a password",
	resetPlaceholder: "Enter your new password",
	submit: "Set password",
	backToLogin: "Back to login",
	requestNewLink: "Request a new link",
};
